export default __webpack_public_path__ + "static/media/digitalmarketing.10241078.svg";